import React from 'react';
import { Container, Accordion, Row, Col } from 'react-bootstrap';
import { FaBell, FaFileAlt, FaHeart, FaClock, FaExclamationTriangle } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AccordionScenario,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

const scenarios = [
  {
    id: 1,
    icon: <FaBell />,
    title: 'W odpowiedzi na argument "Jesteś teraz niezbędny/a w firmie"',
    color: '#667eea',
    argument: 'Nie mogę Ci dać urlopu, bo masz kluczowe zadania i bez Ciebie firma się zawali/nie damy rady.',
    response: 'Rozumiem Pana/Pani obawy co do bieżących potrzeb firmy, ale moje prawo do urlopu w okresie ferii nie jest zależne od potrzeb operacyjnych. Zgodnie z Art. 205 § 3 Kodeksu pracy, pracodawca jest obowiązany udzielić mi urlopu właśnie w tym czasie. Jest to przepis, który chroni moje zdrowie i daje mi możliwość regeneracji po intensywnym okresie nauki, co jest nadrzędne wobec organizacji pracy w firmie.'
  },
  {
    id: 2,
    icon: <FaFileAlt />,
    title: 'W odpowiedzi na odmowę formalnego wniosku o urlop',
    color: '#f093fb',
    argument: '(Po złożeniu wniosku) Odrzucam Twój wniosek. Przyjdź do pracy w ferie, inaczej będziesz mieć nieobecność nieusprawiedliwioną.',
    response: 'Uprzejmie informuję, że odrzucenie wniosku o urlop w okresie ferii narusza Art. 205 § 3 Kodeksu pracy. Ten przepis nakazuje, a nie tylko umożliwia, udzielenie mi urlopu w tym czasie. Muszę stanowczo podkreślić, że moja nieobecność w tym okresie będzie usprawiedliwiona i wynika wprost z przepisów prawa. Proszę o natychmiastowe pozytywne rozpatrzenie mojego wniosku.'
  },
  {
    id: 3,
    icon: <FaHeart />,
    title: 'W odpowiedzi na odwoływanie się do "moralności" i "obowiązków"',
    color: '#4facfe',
    argument: 'Powinieneś/Powinnaś wykazać się lojalnością i zrozumieniem. To Twój obowiązek, żeby pomóc firmie w trudnym czasie.',
    response: 'Doceniam, że Pan/Pani liczy na moją lojalność, jednak moja moralność i obowiązki zawodowe kończą się tam, gdzie zaczyna się łamanie prawa pracy. Nie jestem pełnoprawnym, doświadczonym pracownikiem, lecz osobą, która dopiero uczy się zawodu. Mój urlop jest mi potrzebny do odpoczynku, by wrócić do pracy i nauki z nową energią. Proszę o przestrzeganie moich praw, a nie obciążanie mnie odpowiedzialnością za całą firmę.'
  },
  {
    id: 4,
    icon: <FaClock />,
    title: 'W odpowiedzi na argument "Wolisz urlop bezpłatny zamiast pracy?"',
    color: '#43e97b',
    argument: 'Zużyłeś/aś już swoje dni urlopowe, więc jeśli chcesz wolne, to będzie urlop bezpłatny, na który się nie zgadzam.',
    response: 'Właśnie na tym polega dodatkowa ochrona młodocianych. Nawet jeśli wykorzystałem/am już mój urlop wypoczynkowy, ma Pan/Pani obowiązek udzielić mi urlopu bezpłatnego na mój wniosek, aż do łącznego wymiaru 2 miesięcy wolnego w ferie/wakacje (Art. 205 § 4 KP). Wnoszę o udzielenie mi urlopu na podstawie tego przepisu. Jest to obowiązek pracodawcy, a nie jego dobra wola.'
  },
  {
    id: 5,
    icon: <FaExclamationTriangle />,
    title: 'Przy stanowczym nacisku i konieczności powołania się na konsekwencje',
    color: '#f5576c',
    argument: 'Pracodawca kategorycznie odmawia i grozi, że odmowa będzie miała konsekwencje.',
    response: 'Muszę jasno zaznaczyć: odmawiając mi urlopu w okresie ferii, Pan/Pani łamie Art. 205 § 3 Kodeksu pracy. To działanie jest niezgodne z prawem i ma dla mnie poważne konsekwencje zdrowotne i edukacyjne (brak regeneracji). W przypadku dalszej odmowy, będę zmuszony/a zgłosić to naruszenie Państwowej Inspekcji Pracy (PIP), ponieważ jest to jedno z najpoważniejszych wykroczeń dotyczących praw pracownika młodocianego.'
  }
];

const Vacation = () => {
  return (
    <PageContainer>
      <Container>
        <style>{accordionStyles}</style>
        
        <PageHeader 
          title="Wakacje i ferie"
          subtitle="Szablony rozmów o planowaniu urlopu"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <AnimatedSection>
              <InfoCard>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  Jako pracownik młodociany uczęszczający do szkoły masz prawo do urlopu w okresie ferii szkolnych 
                  (Art. 205 § 3 KP). Pracodawca ma obowiązek udzielić Ci tego urlopu. Dodatkowo możesz otrzymać 
                  urlop bezpłatny do łącznego wymiaru 2 miesięcy (Art. 205 § 4 KP).
                </p>
              </InfoCard>
            </AnimatedSection>

            <Accordion alwaysOpen>
              {scenarios.map((scenario, index) => (
                <AccordionScenario
                  key={scenario.id}
                  scenario={scenario}
                  index={index}
                  eventKey={String(index)}
                  argumentLabel="Argumentacja pracodawcy"
                  responseLabel="Asertywna odpowiedź"
                />
              ))}
            </Accordion>

            <AnimatedSection delay={0.6} className="mt-4 mb-3">
              <InfoCard
                gradient="rgba(255, 0, 0, 0.1)"
                borderColor="rgba(255, 0, 0, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#ff0000' }} />}
                title="Pamiętaj"
              >
                <ul className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.8', color: 'rgba(255,255,255,0.9)' }}>
                  <li className="mb-2">
                    <strong>Art. 205 § 3 KP:</strong> Młodocianemu uczęszczającemu do szkoły należy udzielić urlopu 
                    w okresie ferii szkolnych (przepis nakazowy dla pracodawcy).
                  </li>
                  <li>
                    <strong>Art. 205 § 4 KP:</strong> Pracodawca jest obowiązany na wniosek młodocianego udzielić mu 
                    w okresie ferii szkolnych urlopu bezpłatnego w wymiarze nieprzekraczającym łącznie z urlopem 
                    wypoczynkowym 2 miesięcy.
                  </li>
                </ul>
              </InfoCard>
            </AnimatedSection>

            <AnimatedSection delay={0.65}>
              <InfoCard
                gradient="linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%)"
                borderColor="rgba(255, 193, 7, 0.3)"
              >
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  <strong>Uwaga:</strong> Uniemożliwianie młodocianemu korzystania z urlopu w ferie i wakacje 
                  jest nie tylko nieetyczne, ale łamie przepisy Kodeksu pracy.
                </p>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

export default Vacation;